import { createRoot } from "react-dom/client";
import PublicApp from "./routes/PublicRoutes";
import "./index.css";

// Import i18n configuration - trebuie să fie primul import
import "./i18n/config";

// Register service worker for API caching (performance optimization)
// Defer loading to avoid blocking initial render
import { registerServiceWorker } from "./utils/registerServiceWorker";
// Use requestIdleCallback or setTimeout to defer service worker registration
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    registerServiceWorker();
  }, { timeout: 2000 });
} else {
  // Fallback to setTimeout
  setTimeout(() => {
    registerServiceWorker();
  }, 2000);
}

// Setează ID unic pe elementele <html> și <body> bazat pe schema pentru izolare CSS între aplicații
// Acest lucru ajută la prevenirea conflictelor de stiluri între diferite aplicații/subdomenii
// ID-ul este generat dinamic din schema pentru a suporta orice număr de aplicații
const schema = import.meta.env.VITE_DB_SCHEMA || 'public';
// Generează ID dinamic: înlocuiește underscore-urile cu cratime pentru ID-uri HTML clean
// Ex: 'clients_cmsgo' -> 'app-clients-cmsgo', 'clients_clinicdemo' -> 'app-clients-clinicdemo'
const appId = `app-${schema.replace(/_/g, '-')}`;
document.documentElement.id = appId;
document.body.id = appId;

// Montare React și ascundere loading mask
const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<PublicApp />);
  
  // Marchează body-ul ca fiind montat de React și ascunde loading mask-ul
  // Acest lucru se întâmplă imediat după montare, dar scriptul din HTML va detecta schimbarea
  requestAnimationFrame(() => {
    document.body.classList.add('react-mounted');
    const mask = document.getElementById('react-loading-mask');
    if (mask) {
      mask.classList.add('hidden');
      setTimeout(() => {
        if (mask && mask.parentNode) {
          mask.parentNode.removeChild(mask);
        }
      }, 300);
    }
  });
}

